

export function getHost() {
  if (typeof window === 'undefined') return 'pumpfunsniper.io';
  return window.location.host;
}

export function getOrigin() {
  if (typeof window === 'undefined') return 'https://pumpfunsniper.io';
  return window.location.origin;
}

export const PAYMENT_ADDRESS = '6isiA1t2TKN2ZEw913L85kWZFoqbyVz5a47H6GAYwsdY';

export const RECOMMENDED_START_SOL = 2;

export function shortAddr(addr, left = 4, right = 4) {
  if (!addr) return '';
  if (addr.length <= left + right + 3) return addr;
  return `${addr.slice(0, left)}...${addr.slice(-right)}`;
}

export function buildRefLink(code) {
  return `${getOrigin()}/?ref=${code}`;
}

export function apiBase() {
  
  const host = getHost().replace(/^www\./, '');
  return `https://api.${host}`;
}
